export default {
    url: '/settings',
    template: `
        <div class="col00">
            <ui-view></ui-view>
        </div>
    `,
    abstract: true
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/settings/index.js